<template>
  <div>
    <inline-svg
      :class="{
        invalid1: isInvalid(0),
        focused1: isFocused(0),
        invalid2: isInvalid(1),
        focused2: isFocused(1),
        invalid3: isInvalid(2),
        focused3: isFocused(2)
      }"
      :src="require(`../../assets/dimensions/elements/${imagePath}`)"
      @loaded="setupClickListeners"
    />
  </div>
</template>

<script>
export default {
  name: "VPillShapeFormImage",
  props: ["imagePath", "refs", "focused", "invalid"],
  methods: {
    setupClickListeners() {
      setTimeout(() => {
        this.refs.forEach((ref, index) => {
          this.$el
            .querySelector(`.clickable-part-${index + 1}`)
            .addEventListener("click", () => this.$emit("imagePartClick", ref));
        });
      });
    },
    isFocused(index) {
      return index < this.focused.length ? this.focused[index] : false;
    },
    isInvalid(index) {
      return index < this.invalid.length ? this.invalid[index] : false;
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/variables";

@for $i from 1 through 3 {
  svg.focused#{$i},
  svg.focused#{$i} {
    .fill-to-change-#{$i} {
      fill: #004593;
    }
    .stroke-to-change-#{$i} {
      stroke: #004593;
    }
  }
  svg.focused#{$i}.invalid#{$i} {
    .fill-to-change-#{$i} {
      fill: #004593;
    }
    .stroke-to-change-#{$i} {
      stroke: #004593;
    }
  }
}
</style>
